/// Import theme functions.
import ready from './shared/ready'
import atoms from './atoms/atoms'
import molecules from './molecules/molecules'
import organisms from './organisms/organisms'

// Styles.
import 'selectric/src/selectric.scss'
import './style.scss'

// Call functions when dom is ready.
ready(() => {
  atoms()
  organisms()
  molecules()
})
